import { ClearConnectionResults } from "../../../contracts";
export function unsubscribe(store, conn, r) {
    const x = store.clearConnection(r);
    if (conn.isConnectedSync() &&
        x !== ClearConnectionResults.RemovedConnection &&
        x !== ClearConnectionResults.QueryNotFound) {
        conn.send({
            name: "unsubscribe",
            params: { id: x }
        });
    }
    return x;
}
//# sourceMappingURL=unsubscribe.js.map